import * as React from 'react'
import { Box } from '@mui/material'


export default function numCompetitorsColumn() {
	return {
		name: 'totalCompetitors', label: 'No. Competitors',
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                {value}
            </Box>
		}
	}
}